export const sx = {
    tr: {
        'lightTheme &': {
            borderBottom: '1px solid #5f5f5f1a',
            borderRight: '1px solid #5f5f5f1a',
        },
        'lightTheme. & th:last-child': {
            border: '1px solid #5f5f5f1a!important',
        },
        '.lightTheme & th': {
            border: '1px solid #5f5f5f1a!important',
        }
    }
}